<template>
    <div>
        <div class="modal modal-xl fade" :class="{ 'show d-block': modelValue }" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i v-if="icon" :class="'bi bi-' + icon"></i>
                            {{ title }}
                        </h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="modelValue"></div>
    </div>
</template>

<script>
export default {
    name: 'ModalView',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: ['update:modelValue', 'close'],
    methods: {
        closeModal() {
            this.$emit('update:modelValue', false);
            this.$emit('close');
        }
    }
}
</script>
<style scoped>
.modal-dialog {
    max-height: 90vh;  
}

.modal-content {
    max-height: 90vh;
    overflow: hidden;
}

.modal-body {
    max-height: calc(90vh - 70px); 
    overflow-y: auto;
}
</style>
